import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { getItemValuesForCondition } from './getItemValuesForCondition';
import { toConditionDisplayName } from './toConditionDisplayName';
import { toActionDisplayNames } from './toActionDisplayNames';
import { getMostImportantCondition } from './getMostImportantCondition';
import { ToInlineCommaList, TruncateString } from '../../../../lib/helpers/StringHelper';

export function generateRuleTitle(item: SmartSendItemApiModel, actions: string[], selectedConditions: string[]) {
  const selectedCondition = getMostImportantCondition(selectedConditions);
  return `${toActionDisplayNames(actions)} Rule for ${toConditionDisplayName(selectedCondition)} (${TruncateString(
    ToInlineCommaList(getItemValuesForCondition(item, selectedCondition)),
    25
  )})`;
}
